import { Button } from "@mui/material";
import { forwardRef } from "react";
import { FootPrint, AccountGroup } from "mdi-material-ui"
import { NavLink, useLocation } from "react-router-dom";
import { useAppDispatch } from "store/hooks";
import { setType } from "store/wizard";
import { ActionType } from "store/wizard/types";

export const ForwardNavLink = forwardRef((props: any, ref) => (
  <NavLink {...props} innerRef={ref as any} />
));

const Menu = () => { 
  const location = useLocation();
  const dispatch = useAppDispatch();
  return (
    <>
      <div className="col-12 d-flex justify-content-center mb-5 mt-2"> 
        <div>
          <Button 
            className="me-2"
            variant={(location.pathname.includes("individual") || location.pathname === "/") ? "contained" : "outlined"}
            color="secondary"
            size="large"
            startIcon={<FootPrint/>}
            component={ForwardNavLink}
            to={"/individual"}
            onClick={() => dispatch(setType(ActionType.Individual))}
            >
              Individual
          </Button>
          <Button 
            className="ms-2"
            variant={location.pathname === "/household" ? "contained" : "outlined"}
            color="secondary"
            size="large"
            startIcon={<AccountGroup/>}
            component={ForwardNavLink}
            to={"/household"}
            onClick={() => dispatch(setType(ActionType.Household))}
            >
              Household
          </Button>
        </div>
      </div>
    </>
  );
};
export default Menu;
